import { type vec2 } from 'gl-matrix';

import { type BaseCommandAnalyticsAttributes } from '@canvas/model/analytics-source';
import { type EntityId } from '@canvas/model/ecs';
import type {
  ImporterFileSource,
  ImporterSource,
} from '@canvas/tool-types/importer-types';

import { Command, type BaseCommandProperties } from '../command-definition';

export interface ImportFileCommandProperties extends BaseCommandProperties {
  /**
   * The file data to import.
   */
  blob: Blob;
  /**
   * Where the file import was initiated from, used for analytics.
   * @see canvas-frontend.entities.ts
   */
  source: ImporterSource;
  fileSource: ImporterFileSource;
  maxInitialDisplaySize?: vec2;
  analyticsAttributes?: BaseCommandAnalyticsAttributes;
  /**
   * The id of the entity to import the file into. If not provided, the file will be imported into a new entity.
   */
  targetEntityId?: EntityId;
}
export class ImportFileCommand extends Command<ImportFileCommandProperties> {}
